import React, { useCallback, useEffect, useState } from 'react';
import ToggleSwitch from '../../../../../../components/ui/toggles/ToggleSwitch';

const getCsrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content;

// Busca e grava o status de liberação do plano de forma independente da
// modalidade (nacional/internacional) selecionada nas telas que o usam —
// o /investment_policy?modality=... pode 404 quando o cliente não tem
// carteira configurada para a modalidade em exibição, o que não deve
// derrubar a leitura do status de liberação em si.
const InvestmentPolicyReleaseToggle = ({ clientId, canWrite }) => {
  const [released, setReleased] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(() => {
    fetch(`/app/planner/client/${clientId}/dashboard/investment_strategy/investment_policy`)
      .then((res) => res.json())
      .then((data) => {
        setReleased(data.status === 'released');
      })
      .catch((err) => {
        console.error('Erro ao buscar status da estratégia de investimentos:', err);
      });
  }, [clientId]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  const handleChange = (checked) => {
    const previousValue = released;
    const nextStatus = checked ? 'released' : 'in_preparation';

    setReleased(checked);
    setSaving(true);
    setError(null);

    fetch(`/app/planner/client/${clientId}/dashboard/investment_strategy/investment_policy/status`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
      },
      body: JSON.stringify({
        investment_policy_status: nextStatus,
      }),
    })
      .then(async (res) => {
        const responseData = await res.json();

        if (!res.ok) {
          throw responseData;
        }

        return responseData;
      })
      .then((responseData) => {
        setReleased(responseData.investment_policy_status === 'released');
      })
      .catch((err) => {
        console.error('Erro ao atualizar visualização do cliente:', err);

        setReleased(previousValue);
        setError(err?.error || 'Erro ao atualizar visualização do cliente');
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-3">
        <span className="text-sm font-semibold text-blueSteel">VISUALIZAÇÃO DO CLIENTE:</span>

        {canWrite && <ToggleSwitch checked={released} onChange={handleChange} disabled={saving} />}

        <span className="text-base font-medium">{released ? 'Plano liberado' : 'Plano em manutenção'}</span>
      </div>

      {error && <span className="text-xs font-medium text-red-500">{error}</span>}
    </div>
  );
};

export default InvestmentPolicyReleaseToggle;
